if (!customElements.get('ape-cart-reference')) {
  customElements.define(
    'ape-cart-reference',
    class ApeCartReference extends HTMLElement {
      constructor() {
        super();
        this.saveTimer = null;
        this.addEventListener('input', (event) => this.onInput(event));
        this.addEventListener('change', () => this.queueSave(0));
      }

      onInput(event) {
        const input = event.target.closest('[data-ape-cart-attribute]');
        if (!input) return;

        document.querySelectorAll(`[data-ape-cart-attribute="${input.dataset.apeCartAttribute}"]`).forEach((peer) => {
          if (peer !== input) peer.value = input.value;
        });

        this.queueSave(400);
      }

      queueSave(delay) {
        window.clearTimeout(this.saveTimer);
        this.saveTimer = window.setTimeout(() => this.save(), delay);
      }

      save() {
        const attributes = {};

        ['ape_remise_prenom', 'ape_remise_classe'].forEach((key) => {
          attributes[key] = document.querySelector(`[data-ape-cart-attribute="${key}"]`)?.value || '';
        });

        fetch(routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        }).catch(() => {});
      }
    }
  );
}

if (!window.BernaisseApeCartAttributeCleanup && typeof subscribe === 'function') {
  window.BernaisseApeCartAttributeCleanup = true;

  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    if (!cartData?.items || cartData.items.some((item) => item.properties?._ape_code)) return;

    fetch(routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          ape_remise_prenom: '',
          ape_remise_classe: '',
        },
      }),
    }).catch(() => {});
  });
}
